import { OlVectorLayer } from "@daniellang/schulwegeplan/components/ol/layers/ol-vector-layer";

import { Vector } from "ol/source";
import VectorSource from "ol/source/Vector";
import Feature from "ol/Feature";
import Style, { StyleLike } from 'ol/style/Style';
import { FlatStyleLike } from "ol/style/flat";
import Icon from "ol/style/Icon";
import { Point } from "ol/geom";
import { fromLonLat } from "ol/proj";

import { customElement } from "lit/decorators.js";

import markerIconSvg from "../../assets/svg/pin.svg";

const schoolCoordinate = fromLonLat([8.239884701438207, 49.40202872316275], 'EPSG:3857');

@customElement("swp-school")
export class SwpSchoolLayer extends OlVectorLayer {

    protected createStyle(): StyleLike | FlatStyleLike | null | undefined {
        return new Style({
            image: new Icon({
                src: markerIconSvg,
                scale: 0.055,
                anchorOrigin: "bottom-left",
                anchor: [0.5, 0]
            }),
        });
    }

    protected createSource(): Vector {
        const schoolSource = new VectorSource();

        schoolSource.addFeature(new Feature({
            geometry: new Point(schoolCoordinate),
        }));
        
        return schoolSource;
    }

}